import * as actionTypes from './actionTypes';
import axios from '../../axios-order';
export const purchaseBurgerSuccess = (id,orderData) => {
    return {
        type:actionTypes.PURCHASE_BURGER_SUCCESS,
        orderId:id,
        orderData:orderData
    };
};

export const purchaseBurgerFail = (error) => {
    return {
        type:actionTypes.PURCHASE_BURGER_FAIL,
        error:error
    };
};

export const purchaseBurgerStart = () => {
    return {
        type:actionTypes.PURCHASE_BURGER_START
    }
}


export const purchaseBurger = (orderData,token) => {
    purchaseBurgerStart();
    return dispatch => {
        axios.post( '/order.json?auth=' + token, orderData )
        .then( response => {
            console.log(response.data);
            dispatch(purchaseBurgerSuccess(response.data.name,orderData));
            //this.props.history.push('/');
        } )
        .catch( error => {
            dispatch(purchaseBurgerFail(error));
        } );
    };
};

export const purchaseInit= () => {
    return {
        type:actionTypes.PURCHASE_INIT
    };

};

export const fetchOrdersSuccess= (orders) =>{
    return {
        type:actionTypes.FETCH_ORDERS_SUCCESS,
        orders:orders
    };
};

export const fetchOrderFail = (error) => {
    return {
        type:actionTypes.FETCH_ORDERS_FAIL,
        error:error
    };
};

export const fetchOrdersStart = () => {
    return {
        type:actionTypes.FETCH_ORDERS_START
    };
}

export const fetchOrder= (token,userId) => {
    return dispatch => {
        dispatch(fetchOrdersStart());
        const queryParams = '?auth=' + token + '&orderBy="userId"&equalTo="' + userId +'"';
        axios.get('/order.json'+queryParams)
        .then(res=>{
            const fetchOrders=[];
            for(let key in res.data){
                fetchOrders.push({
                    ...res.data[key],
                    id:key
                });
                dispatch(fetchOrdersSuccess(fetchOrders))
               // this.setState({loading:false,orders:fetchOrders});
              //  console.log(res);
            }
        })
        .catch(err=>{
            console.log(err);
            dispatch(fetchOrderFail(err));
         //   this.setState({loading:false});
        });
    }

    
}